import { useMemo } from 'react';

import { useFormat } from '@nucleus-commerce/i18n/react';

/** Seconds as the largest sensible unit: 45 s, 3.5 min, 2.1 h; an em dash when there is none. */
export function useDurationFormat() {
  const format = useFormat();
  return useMemo(
    () => (seconds: number | null) => {
      if (seconds === null) return '—';
      const unit = (value: number, name: 'second' | 'minute' | 'hour' | 'day') =>
        format.number(value, {
          style: 'unit',
          unit: name,
          unitDisplay: 'short',
          maximumFractionDigits: 1,
        });
      if (seconds < 60) return unit(seconds, 'second');
      if (seconds < 3600) return unit(seconds / 60, 'minute');
      if (seconds < 86_400) return unit(seconds / 3600, 'hour');
      return unit(seconds / 86_400, 'day');
    },
    [format],
  );
}
